import { ArrowRight, Instagram } from "@components/Icons"
import { useIntl } from "@components/Intl"
import React from "react"
import * as S from "./elements"

const instagramFilterUrl = "https://www.instagram.com/ar/415524886794472/"

export const InstagramFilterCard: React.FC = () => {
  const { messages } = useIntl()
  return (
    <S.Wrapper>
      <S.Description>{messages.global.checkInstagramFilter}</S.Description>
      <S.Content href={instagramFilterUrl} target="blank">
        <S.InstagramLogo>
          <Instagram />
        </S.InstagramLogo>
        <S.TextAndArrow>
          <S.InstagramButton as="span">INSTAGRAM FILTER</S.InstagramButton>
          <ArrowRight />
        </S.TextAndArrow>
      </S.Content>
    </S.Wrapper>
  )
}
